import { Box, Grid, Step, StepContent, StepLabel, Stepper, Container } from '@material-ui/core';
import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { TrackRecordFirstStep } from './subcomponents/trackRecordFirstStep/trackRecordFirstStep';
import { TrackRecordThirdStep } from './subcomponents/trackRecordThirdStep/trackRecordThirdStep';
import { useEffect } from 'react';
import { PreScreenBorrowerTierRating } from '@roc/feature-borrowers';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => {
  return {
    button: {
      marginRight: theme.spacing(1),
    },
    reverseWrap: {
      flexWrap: 'wrap-reverse'
    }
  };
});

const STEPS = [
  'Track Record',
  'Borrower Entities',
  'GC / Real Estate Broker',
];

export const BorrowerTrackRecordVerification = observer(({
  token,
  isInternal = false,
  isTpoFlow = false,
  store,
  showBanner = true,
  borrowerId = null,
  onDocUploadCallback = () => { },
  onClose
}) => {
  const { borrowerTrackRecordVerificationStore } = store;
  const { borrowerTier, activeStep, trackRecordOtherFormStore } = borrowerTrackRecordVerificationStore;
  const classes = useStyles();

  useEffect(() => {
    borrowerTrackRecordVerificationStore.setCurrentToken(token);
    borrowerTrackRecordVerificationStore.checkBorrowerId(borrowerId);
    borrowerTrackRecordVerificationStore.fetchBorrowerInfo();
    borrowerTrackRecordVerificationStore.resetActiveStep();
    borrowerTrackRecordVerificationStore.setIsTpoFlow(isTpoFlow);
    borrowerTrackRecordVerificationStore.getLoanBorrowerDocuments(store?.documentStore?.loanStore?.loanDetails?.loanId);
  }, []);

  const handleBack = () => {
    borrowerTrackRecordVerificationStore.goPrevStep();
  }

  const handleNext = () => {
    borrowerTrackRecordVerificationStore.validateTrackRecordTemplate();
    borrowerTrackRecordVerificationStore.saveAndUploadGCAndBrokerData((token) => store.fetchPublicFormInformation(token));
    // borrowerTrackRecordVerificationStore.goNextStep();
  }

  return (
    <>
      {showBanner && (
        <Container>
          <Box mb={10}>
            <Alert severity="info">
              If you have already sent this information, you do not need to fill it out again.
            </Alert>
          </Box>
        </Container>
      )}


      <Grid container spacing={2} className={classes.reverseWrap}>
        <Grid item xs={12} md={12} xl={12} style={{
          width: '100%',
          padding: '0px 12px',
          margin: 0,
          marginTop: '-24px'
        }}>
          <Grid container direction='row' spacing={0} justifyContent='flex-start' style={{
            width: '100%',
            flexGrow: 1,
          }}>
            <Grid item xs={12}>
              <TrackRecordThirdStep store={borrowerTrackRecordVerificationStore} />
              {trackRecordOtherFormStore.form.fields.previousExperience.value === 'Yes' &&
                (<TrackRecordFirstStep store={borrowerTrackRecordVerificationStore} onDocUploadCallback={onDocUploadCallback} />)}
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'right', marginTop: '10px', marginBottom: '10px' }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={onClose}
                testId={activeStep === STEPS.length - 1 ? `finish` : `next-${activeStep + 1}`}
                className={classes.button}
                style={{ backgroundColor: 'transparent' }}
              >
                {'Cancel'}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                testId={activeStep === STEPS.length - 1 ? `finish` : `next-${activeStep + 1}`}
                className={classes.button}
              >
                {'Save and Finish'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
